import { Navigate, Routes, Route } from 'react-router-dom';

import Landing from '../pages/Landing'
import SignIn from '../pages/SignIn'
import Dashboard from '../pages/Dashboard'
import Profile from '../pages/Profile'
import Debits from '../pages/Debits'
import Groups from '../pages/Groups'
import Simulation from '../pages/Simulation'
import Investimento from '../pages/Investimentos'
import IncomeHistory from '../pages/IncomeHistory'
import TermsOfUse from '../pages/TermsOfUse'
import PrivacyPolicy from '../pages/PrivacyPolicy'
import Achievements from '../pages/Achievements'

import RequireAuth from './requireAuth'
import RequirePro from './requirePro'

export default function Rotas() {

  return (
    <Routes>
      <Route
        path="/pages/termos-de-uso"
        element={<TermsOfUse />}
      />

      <Route
        path="/pages/politica-de-privacidade"
        element={<PrivacyPolicy />}
      />

      <Route
        path="/"
        element={<Landing />}
      />

      <Route
        path="/signin"
        element={<SignIn />}
      />

      <Route
        path="/login"
        element={<Navigate to="/signin" replace />}
      />

      <Route
        path="/dashboard"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <Dashboard />
          </RequireAuth>
        }
      />

      <Route
        path="/profile"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <Profile />
          </RequireAuth>
        }
      />

      <Route
        path="/simulation"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <RequirePro>
              <Simulation />
            </RequirePro>
          </RequireAuth>
        }
      />

      <Route
        path="/investimentos"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <RequirePro>
              <Investimento />
            </RequirePro>
          </RequireAuth>
        }
      />

      <Route
        path="/debits"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <Debits />
          </RequireAuth>
        }
      />

      <Route
        path="/groups"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <Groups />
          </RequireAuth>
        }
      />

      <Route
        path="/conquistas"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <Achievements />
          </RequireAuth>
        }
      />

      <Route
        path="/income-history"
        element={
          <RequireAuth redirectTo="/signin" isPrivate>
            <IncomeHistory />
          </RequireAuth>
        }
      />

    </Routes>
  )
}
